import { render, staticRenderFns } from "./Unit.vue?vue&type=template&id=53364fbd&lang=true&"
import script from "./Unit.vue?vue&type=script&lang=js&"
export * from "./Unit.vue?vue&type=script&lang=js&"
import style0 from "./Unit.vue?vue&type=style&index=0&id=53364fbd&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports